<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row align-items-center mb-3">
                <div class="col-3 mb-3 mb-lg-0">
                  <router-link
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                    :to="{ name: 'AddHighlightedBrand' }"
                  >
                    + Dodaj istaknuti brand
                  </router-link>
                </div>
                <div
                    class="col-9 ps-lg-1 mb-3 mb-lg-0 d-flex justify-content-end align-items-center gap-1"
                  >
                    <treeselect
                      v-model="contentType"
                      class="w-25 custom-vue-tree-select"
                      :options="b2bOrb2cOptions"
                      placeholder="B2B/B2C"
                    />
                    <div class="d-flex align-items-lg-center">
                      <select
                        class="form-control select-style-1 results-per-page"
                        name="results-per-page"
                        v-model="searchConfig.pageSize"
                        @change="changePageSize(searchConfig.pageSize)"
                      >
                        <option
                          :value="page"
                          v-for="page in pageSizeList"
                          :key="page"
                        >
                          {{ page }}
                        </option>
                      </select>
                    </div>

                    <div class="search search-style-1 search-style-1-lg">
                      <div class="input-group">
                        <input
                          type="text"
                          class="search-term form-control"
                          placeholder="Search"
                          v-model="searchField"
                          @input="debounceInput"
                        />
                        <button class="btn btn-default" type="submit">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </div>

            <div
              class="dataTables_wrapper dt-bootstrap5 no-footer"
              v-if="list.length > 0"
            >
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Name</th>
                      <th class="sorting">Naslov</th>
                      <th class="sorting">Glavni naslov</th>
                      <th class="sorting">Karakteristike</th>
                      <th class="sorting">Količina popusta</th>
                      <th class="sorting">Dodatni sadržaj</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(brand, index) in list"
                      :key="brand.id"
                      @click="openDetails(brand.id)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="brand.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                        <strong>{{
                          (pager.currentPage - 1) * searchConfig.pageSize +
                          index +
                          1
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{ brand.title }}</strong>
                      </td>
                      <td>{{ brand.text_1 }}</td>
                      <td>{{ brand.text_2 }}</td>
                      <td>{{ brand.text_3 }}</td>
                      <td>{{ brand.text_4 }}</td>
                      <td>{{ brand.text_5 }}</td>
                      <td>{{ formatDate(brand.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }}
                <a class="alert-link" @click.prevent="resetFilters">{{
                  translations.resetFilters
                }}</a
                >.
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                      >
                        {{ translations.apply }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" :pagination-props="paginationProps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="handleBulkAction"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { translations, pager } from '@/mixins';
import Pagination from '../../shared/Pagination.vue';
import Modal from '../../shared/modal/Modal.vue';

export default {
  name: 'HighlightedBrands',
  components: { Treeselect, Pagination, Modal },
  mixins: [translations, pager],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getHighlightedBrands',
      deleteActionName: 'deleteHighlightedBrands',
      bulkActionName: 'deleteHighlightedBrands',
      contentType: query?.contentType || null,
    };
  },
  computed: {
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
        { id: 3, label: 'Sve' },
      ];
    },
    list() {
      return this.$store.getters.getHighlightedBrands;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    paginationProps() {
      return {
        contentType: this.contentType,
      };
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditHighlightedBrand', params: { id: id } });
    },
  },
  watch: {
    contentType() {
      this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
      this.$router
        .push({
          query: {
            ...this.searchConfig,
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>

<style lang="scss">
.vue-treeselect {
  min-height: 47px;
}

.vue-treeselect__control {
  min-height: 47px;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}

.vue-treeselect__value-container {
  min-height: 47px;
}

.results-per-page {
  min-width: 60px;
}
</style>
